/* IntelApps — 404 Not Found Page */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n.js';
import Header from '../parts/Header.js';
import Footer from '../parts/Footer.js';
import notFoundImg from '../assets/images/hero/404.png';

export default function NotFoundPage() {
  const { t } = useI18n();

  useEffect(() => {
    document.title = 'IntelApps — 404';
  }, []);

  return (
    <>
      <Header />
      <main>
        <section className="page-hero">
          <div className="container">
            <div className="page-hero-grid" style={{ alignItems: 'center' }}>
              <div>
                <p className="eyebrow">{t.notFound.eyebrow}</p>
                <h1>{t.notFound.title}</h1>
                <p className="page-hero-sub">{t.notFound.description}</p>

                <div className="hero-cta" style={{ marginTop: 28 }}>
                  <Link to="/" className="btn btn-primary">
                    {t.notFound.backHome}
                  </Link>
                </div>
              </div>

              <div className="page-hero-media">
                <img src={notFoundImg} alt="404" />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
